// shopping types
export default {
  TOGGLE_SKINNY_NAV: 'TOGGLE_SKINNY_NAV',
  TOGGLE_DRAWER: 'TOGGLE_DRAWER',
};
